import moment from 'moment';
import { ADDRESS_LIST_RESPONSE } from './parent/address';

export enum STEP_STATUS_LABEL {
  requested = 'Requested',
  sitterMatched = 'Sitter Matched',
  sitterAccepted = 'Sitter Accepted',
  trialCreated = 'Trial Created',
  trialArranged = 'Trial Arranged',
  trialCompleted = 'Trial Completed',
  commenced = 'Commenced',
  completed = 'Completed',
}

export enum AC_BASE_REQUEST_STATUS {
  PENDING_PAYMENT = 'pending_payment',
  SEARCH_REQUESTED = 'search_requested',
  SEARCH_FOUND = 'search_found',
  PARENT_ACCEPTED = 'parent_accepted',
  TRIAL_CREATED = 'trial_created',
  TRIAL_PAID = 'trial_paid',
  TRIAL_COMPLETED = 'trial_completed',
  PAYMENT_COMPLETED = 'payment_completed',
  PAYMENT_FAILED = 'payment_failed',
  ACTIVE = 'active',
  CLOSED = 'closed',
}

export const mapBaseRequestTitle = {
  [AC_BASE_REQUEST_STATUS.ACTIVE]: 'Active',
  [AC_BASE_REQUEST_STATUS.CLOSED]: 'Completed',
  [AC_BASE_REQUEST_STATUS.PARENT_ACCEPTED]: 'Accepted',
  [AC_BASE_REQUEST_STATUS.PENDING_PAYMENT]: 'Pending Payment',
  [AC_BASE_REQUEST_STATUS.SEARCH_FOUND]: 'Search Found',
  [AC_BASE_REQUEST_STATUS.TRIAL_COMPLETED]: 'Trial Completed',
  [AC_BASE_REQUEST_STATUS.TRIAL_CREATED]: 'Trial Created',
  [AC_BASE_REQUEST_STATUS.TRIAL_PAID]: 'Trial Arranged',
  [AC_BASE_REQUEST_STATUS.SEARCH_REQUESTED]: 'Search Requested',
  [AC_BASE_REQUEST_STATUS.PAYMENT_COMPLETED]: 'Payment Completed',
  [AC_BASE_REQUEST_STATUS.PAYMENT_FAILED]: 'Payment Failed',
};

export const mapBaseRequestColor = {
  [AC_BASE_REQUEST_STATUS.ACTIVE]: 'secondary.main',
  [AC_BASE_REQUEST_STATUS.CLOSED]: '#B6B6B6',
  [AC_BASE_REQUEST_STATUS.PARENT_ACCEPTED]: 'secondary.main',
  [AC_BASE_REQUEST_STATUS.PENDING_PAYMENT]: 'primary.main',
  [AC_BASE_REQUEST_STATUS.SEARCH_FOUND]: 'secondary.main',
  [AC_BASE_REQUEST_STATUS.TRIAL_COMPLETED]: 'secondary.main',
  [AC_BASE_REQUEST_STATUS.TRIAL_CREATED]: 'secondary.main',
  [AC_BASE_REQUEST_STATUS.TRIAL_PAID]: 'secondary.main',
  [AC_BASE_REQUEST_STATUS.SEARCH_REQUESTED]: 'secondary.main',
  [AC_BASE_REQUEST_STATUS.PAYMENT_COMPLETED]: 'primary.main',
  [AC_BASE_REQUEST_STATUS.PAYMENT_FAILED]: 'red.dark',
};

export enum AC_BASE_REQUEST_MODAL_TYPE {
  TERMS = 'TERMS',
  ADDRESS = 'ADDRESS',
}

export enum ENUM_TYPE_OF_TERMS {
  SEARCH_FEE = 'search-fee',
  TRIAL = 'trial',
  PACKAGES = 'packages',
  NON_SOLICITATION = 'non-solicitation',
}

/* =========== INTERFACE ============ */

export interface DATA_CREATE_REQUEST_SUMMARY {
  addChild: ADD_CHILD_DATA;
  requestDetail: REQUEST_DETAIL_DATA;
  parentSignature: string;
}

export interface CHILD_ITEM_TYPE {
  id: string;
  name: string;
  date_of_birth: string;
}

export interface ADD_CHILD_DATA {
  children: CHILD_ITEM_TYPE[];
  isAccepted: boolean;
}

export interface REQUEST_DETAIL_ADDRESS {
  id: string | number;
  address: string;
}
export interface REQUEST_DETAIL_PET {
  id: string;
  name: string;
}
export interface REQUEST_DETAIL_DATA {
  startDate: moment.Moment;
  endDate: moment.Moment;
  startTime: Date;
  endTime: Date;
  dayOfWeeks: string[];
  specialRequirements: string;
  pets: string[];
  children: CHILD_ITEM_TYPE[];
  address: ADDRESS_LIST_RESPONSE;
  isAccepted: boolean;
}

export interface PARAMS_REQUEST_DETAIL {
  start_datetime: string;
  end_datetime: string;
  days_of_week: number[];
  address_id: string;
  children_ids: string[];
  pets: {
    cats: boolean;
    dogs: boolean;
  };
  special_requirements: string;
}
